import { observer } from 'mobx-react-lite';
import useStore from 'reusable/mobx-store-utils'
import XeroAuthButton from 'features/xero-sso/XeroAuthButton'
import useQuery from 'reusable/hooks/useQuery';
import SignUpWithXeroStore from './SignUpWithXeroStore';
import { useAuthStore } from 'auth/AuthStore';
import { useRegionRouterStore } from 'features/main/RegionRouterStore';

export default observer(function SignUpWithXero() {
   const authStore = useAuthStore()
   const queryString = useQuery()
   const regionRouterStore = useRegionRouterStore()
   const signUpWithXeroStore = useStore(sp => new SignUpWithXeroStore(sp), { email: queryString.get('email'), authStore, regionRouterStore })

   return <XeroAuthButton onClick={signUpWithXeroStore.signUpWithXero} />
}) 